<style lang="less">
  .anchorBL{ display: none !important;}
  .arco-picker-input { background: transparent !important; }


  .aform{
    .arco-form-item{
      padding: 0; margin-bottom: 20px;
      .arco-form-item-wrapper{
        flex: 1;
        .arco-input-wrapper, .arco-select-view, .arco-picker{ width: 100%; }
        /* 富文本编辑器：覆盖 Arco Form 的 flex 布局，强制上下排列 */
        &.arco-form-content-flex {
          display: block !important;
        }
        .fform-quill-wrap {
          width: 100%;
        }
      }
      .arco-upload-list-item{
        margin: 0 10px 0 0;
      }
      .arco-form-item-label{
        line-height: 32px; padding: 0; min-width: 60px;
      }
    }
  }

  /* ========== 富文本编辑器（Quill）========== */
  /* QuillEditor 根元素（class="fform-quill-editor" 挂在这个 div 上）*/
  .fform-quill-editor {
    width: 100% !important;
    display: block !important;

    > .ql-toolbar {
      border-color: var(--border-color, #e5e6eb) !important;
      background: var(--card-bg, #fff);
      border-radius: 4px 4px 0 0;
      display: block !important;
    }

    > .ql-container {
      border-color: var(--border-color, #e5e6eb) !important;
      background: var(--card-bg, #fff);
      border-radius: 0 0 4px 4px;
      min-height: 300px !important;
      display: block !important;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'PingFang SC', sans-serif;
      font-size: 14px;

      .ql-editor {
        min-height: 280px !important;
        color: var(--text-color, #1d2129);
        &.ql-blank::before {
          color: var(--text-secondary, #86909c) !important;
          font-style: normal;
        }
      }
    }

    /* 暗色主题适配 */
    body[arco-theme] & {
      > .ql-toolbar {
        background: var(--card-bg, #262626);
        border-color: var(--border-color, #363636) !important;
        .ql-picker-label, button, span[data-label] {
          color: var(--text-color, #c9cdd4) !important;
        }
        .ql-stroke { stroke: var(--text-color, #c9cdd4) !important; }
        .ql-fill { fill: var(--text-color, #c9cdd4) !important; }
      }
      > .ql-container {
        background: var(--card-bg, #262626);
        border-color: var(--border-color, #363636) !important;
      }
    }
  }
</style>
<style lang="less" scoped>
  @import "~@/public/less/index.less";
  .fan-component{
    .aform{
      padding: 20px 0 0 0;
    }
    .map{
      width: 100%; height: 300px; border: 1px solid #d9d9d9; border-radius: 4px; padding: 5px;
    }
    .esign{
      width:100%;height:100px;
    }


    /* ========== 富文本编辑器（Quill）— scoped 高优先级覆盖 ========== */
    .fform-quill-wrap {
      width: 100%;
      :deep(.fform-quill-editor) {
        display: block !important;
        width: 100% !important;
      }
      :deep(.ql-toolbar) {
        display: block !important;
        width: 100% !important;
      }
      :deep(.ql-container) {
        display: block !important;
        width: 100% !important;
        min-height: 300px !important;
      }
      :deep(.ql-editor) {
        min-height: 280px !important;
      }
    }

    /* ========== 数字+单位组合控件 ========== */
    .unit-suffix {
      display: inline-flex;
      align-items: center;
      height: 32px;
      padding: 0 10px;
      font-size: 14px;
      color: #86909c;
      background: var(--color-fill-2, #f2f3f5);
      border: 1px solid var(--color-border-2, #c5cdd7);
      white-space: nowrap;
      user-select: none;
    }
  }
</style>

<template>
  <div class="fan fan-component">
    <a-form class="aform" :model="form" layout="horizontal"
            :label-col-props="{ flex: '110px' }"
            :wrapper-col-props="{ flex: '1' }">
      <a-row :gutter="24">
      <template v-for="(column, field) in columns" v-if="form && columns">
        <template v-if="!defaultFormValue[field]">
          <a-col :span="colSpanAuto" :key="field + '-col'">
          <!--正整数-->
          <a-form-item v-if="column.form==='number'" :key="field + '-number'"
                       :label="column.name"
                       :required="column.required||false" >
            <template v-if="column.unit">
              <a-input-group style="width:100%">
                <a-input-number :min="0" v-model="form[field]" :disabled="column.disabled||false" :style="{ flex: 1 }" />
                <span class="unit-suffix">{{ column.unit }}</span>
              </a-input-group>
            </template>
            <a-input-number v-else :min="0" v-model="form[field]" :disabled="column.disabled||false" />
          </a-form-item>
          <!--正整数100-->
          <a-form-item v-else-if="column.form==='number100'" :key="field + '-number100'"
                       :label="column.name"
                       :required="column.required||false" >
            <template v-if="column.unit">
              <a-input-group style="width:100%">
                <a-input-number :min="0" :max="100" v-model="form[field]" :disabled="column.disabled||false" :style="{ flex: 1 }" />
                <span class="unit-suffix">{{ column.unit }}</span>
              </a-input-group>
            </template>
            <a-input-number v-else :min="0" :max="100" v-model="form[field]" :disabled="column.disabled||false" />
          </a-form-item>
          <!--小数-->
          <a-form-item v-else-if="column.form==='decimal'" :key="field + '-decimal'"
                       :label="column.name"
                       :required="column.required||false" >
            <template v-if="column.unit">
              <a-input-group style="width:100%">
                <a-input-number :min="0" :step="0.1" v-model="form[field]" :placeholder="column.placeholder||column.name" :disabled="column.disabled||false" :style="{ flex: 1 }" />
                <span class="unit-suffix">{{ column.unit }}</span>
              </a-input-group>
            </template>
            <a-input-number v-else :min="0" :step="0.1" v-model="form[field]" :placeholder="column.placeholder||column.name" :disabled="column.disabled||false" />
          </a-form-item>
          <!--数字带单位选择（单位存DB）-->
          <a-form-item v-else-if="column.form==='numberWithUnit'" :key="field + '-numberUnit'"
                       :label="column.name"
                       :required="column.required||false" >
            <div style="display:flex;align-items:stretch;width:100%">
              <a-input-number :min="0"
                              v-model="form[field]"
                              :disabled="column.disabled||false"
                              style="flex:1;min-width:0;border-top-right-radius:0;border-bottom-right-radius:0" />
              <a-select v-model="form[getUnitField(column, field)]"
                        allow-clear
                        placeholder="单位"
                        :disabled="column.disabled||false"
                        style="width:100px;flex-shrink:0;border-top-left-radius:0;border-bottom-left-radius:0;border-left:0">
                <a-option v-for="opt in (data.options[getUnitField(column, field)] || [])" :key="opt.value" :value="opt.value">{{ opt.label }}</a-option>
              </a-select>
            </div>
          </a-form-item>
          <!--密码-->
          <a-form-item v-else-if="column.form==='password'" :key="field + '-password'"
                       :label="column.name"
                       :required="column.required||false" >
            <a-input v-model="form[field]"
                    type="password"
                    :placeholder="column.placeholder||column.name"
                     :disabled="column.disabled||false" />
          </a-form-item>
          <!--字符串-->
          <a-form-item v-else-if="column.form==='input'" :key="field + '-input'"
                       :label="column.name"
                       :required="column.required||false" >
            <a-input v-model="form[field]"
                     :placeholder="column.placeholder||column.name"
                     :disabled="column.disabled||false" />
          </a-form-item>
          <!--文本域-->
          <a-form-item v-else-if="column.form==='textarea'" :key="field + '-textarea'"
                       :label="column.name"
                       :required="column.required||false" >
            <a-textarea :auto-size="{ minRows: 4 }"
                        v-model="form[field]"
                        :placeholder="column.placeholder||column.name"
                        :disabled="column.disabled||false" />
          </a-form-item>
          <!--富文本编辑器 (Quill)-->
          <a-form-item v-else-if="column.form==='editor'" :key="field + '-editor'"
                       :label="column.name"
                       :required="column.required||false" >
            <div class="fform-quill-wrap">
            <QuillEditor class="fform-quill-editor"
                          v-model:content="form[field]"
                          contentType="html"
                          :options="quillOptions(field)"
                          :disabled="column.disabled||false"
                          @update:content="onEditorChange($event, field)" />
            </div>
          </a-form-item>
         <!--富文本 Quill 编辑器（带图片上传）-->
          <a-form-item v-else-if="column.form==='quilleditor'" :key="field + '-quill'"
                       :label="column.name"
                       :required="column.required||false" >
            <div class="fform-quill-wrap">
            <QuillEditor ref="'ql_'+field"
                         class="fform-quill-editor"
                         v-model:content="form[field]"
                         contentType="html"
                         :options="quillOptionsWithImage(field)"
                         :disabled="column.disabled||false"
                         @update:content="onEditorChange($event, field)"
                         @text-change="onQuillTextChange($event, field)" />
            </div>
          </a-form-item>
          <!--富文本2（精简工具栏 Quill）-->
          <a-form-item v-else-if="column.form==='quilleditor2'" :key="field + '-quill2'"
                       :label="column.name"
                       :required="column.required||false" >
            <div class="fform-quill-wrap">
            <QuillEditor class="fform-quill-editor"
                          v-model:content="form[field]"
                          contentType="html"
                          :options="quillOptionsSimple()"
                          :disabled="column.disabled||false"
                          @update:content="onEditorChange($event, field)" />
            </div>
          </a-form-item>
          <!--代码编辑器-->
          <a-form-item v-else-if="column.form==='code'" :key="field + '-code'"
                       :label="column.name"
                       :required="column.required||false" >
            <f-code-editor :show-btns="false"
                           v-model="form[field]"
                           :disabled="column.disabled||false" />
          </a-form-item>
          <!--标签：输入确认后添加标签-->
          <a-form-item v-else-if="column.form==='tags'" :key="field + '-tags'"
                       :label="column.name"
                       :required="column.required||false" >
            <a-input-tag v-model="form[field]"
                         :placeholder="column.placeholder||'输入后按回车确认'"
                         :disabled="column.disabled||false"
                         allow-clear />
          </a-form-item>
          <!--开关-->
          <a-form-item v-else-if="column.form==='switch'" :key="field + '-switch'"
                       :label="column.name"
                       :required="column.required||false" >
            <a-switch v-model="form[field]"
                      :disabled="column.disabled||false" />
          </a-form-item>
          <!--单选框-->
          <a-form-item v-else-if="column.form==='radio'" :key="field + '-radio'"
                       :label="column.name"
                       :required="column.required||false" >
            <a-radio-group v-model="form[field]"
                           :disabled="column.disabled||false" >
              <a-radio v-for="option in data.options[field]" :key="option.value" :value="option.value">{{option.label}}</a-radio>
            </a-radio-group>
          </a-form-item>
          <!--单方选框-->
          <a-form-item v-else-if="column.form==='checkbox1'" :key="field + '-checkbox1'"
                       :label="column.name"
                       :required="column.required||false" >
            <a-checkbox v-model="form[field]"
                              :disabled="column.disabled||false" >{{data.options[field]?.[0]?.label}}</a-checkbox>
          </a-form-item>
          <!--多选框-->
          <a-form-item v-else-if="column.form==='checkbox'" :key="field + '-checkbox'"
                       :label="column.name"
                       :required="column.required||false" >
            <a-checkbox-group v-model="form[field]"
                              :disabled="column.disabled||false" >
              <a-checkbox v-for="option in data.options[field]" :key="option.value" :value="option.value">{{option.label}}</a-checkbox>
            </a-checkbox-group>
          </a-form-item>
             <!--下拉单选id字符   :allowClear="true" 这个清除 25-11-19 修复-->
          <a-form-item v-else-if="column.form==='id' || column.form==='selectString'" :key="field + '-selectString'"
                       :label="column.name"
                       :required="column.required||false" >
            <a-select v-model="form[field]"
                      allow-clear
                      filterable
                      :placeholder="column.placeholder||column.name"
                      :disabled="column.disabled||false" >
              <a-option v-for="option in data.options[field]" :key="option.value" :value="option.value">{{option.label}}</a-option>
            </a-select>
          </a-form-item>
          <!--下拉单选-->
          <a-form-item v-else-if="column.form==='select'" :key="field + '-select'"
                       :label="column.name"
                       :required="column.required||false" >
            <a-select v-model="form[field]"
                      style="min-width: 100%"
                      allow-clear
                      allow-search
                      :placeholder="(data.options[field] && data.options[field].length) ? column.placeholder||column.name : '加载选项中...'"
                      :disabled="column.disabled||false"
                      @change="(val)=>bindSelectLabelChange(field, val, column)" >
              <a-option v-for="option in (data.options[field] || [])" :key="option.value" :value="option.value">{{ option.label }}</a-option>
            </a-select>
          </a-form-item>
          <!--下拉多选-->
          <a-form-item v-else-if="column.form==='selectMultiple'" :key="field + '-selectMultiple'"
                       :label="column.name"
                       :required="column.required||false" >
            <a-select v-model="form[field]"
                      multiple
                      :placeholder="column.placeholder||column.name"
                      :disabled="column.disabled||false" >
              <a-option v-for="option in data.options[field]" :key="option.value" :value="option.value">{{option.label}}</a-option>
            </a-select>
          </a-form-item>
          <!--下拉树（单选）-->
          <a-form-item v-else-if="column.form==='selectTree'" :key="field + '-selectTree'"
                       :label="column.name"
                       :required="column.required||false" >
            <a-tree-select v-model="form[field]"
                           :tree-checkable="column.checkable === true"
                           :placeholder="column.placeholder||column.name"
                           :data="computedTreeData(field)"
                           :disabled="column.disabled||false"
                           default-expand-all
                           allow-clear allow-search
                           style="width:100%" />
          </a-form-item>
          <!--下拉树（多选）-->
          <a-form-item v-else-if="column.form==='selectTreeMultiple'" :key="field + '-selectTreeMultiple'"
                       :label="column.name"
                       :required="column.required||false" >
            <a-tree-select v-model="form[field]"
                           :tree-checkable="true"
                           :tree-checked-strategy="column.parentDisabled === true ? 'child' : 'all'"
                           :placeholder="column.placeholder||column.name"
                           :data="computedTreeData(field)"
                           :disabled="column.disabled||false"
                           default-expand-all
                           allow-clear allow-search
                           style="width:100%" />
          </a-form-item>
          <!--图标选择（实时预览，支持 Arco 图标与自定义 SVG）-->
          <a-form-item v-else-if="column.form==='icon'" :key="field + '-icon'"
                       :label="column.name"
                       :required="column.required||false" >
            <a-space>
              <a-input v-model="form[field]"
                       :placeholder="column.placeholder||'Arco 图标名(如 user) 或 svg-aq'"
                       :disabled="column.disabled||false"
                       style="width:220px" />
              <svg-icon v-if="isSvgIcon(form[field])" :name="svgName(form[field])" :size="20" />
              <component v-else-if="form[field]" :is="iconPreview(form[field])" style="font-size:20px" />
              <a-popover trigger="click" position="bottom">
                <a-button>选择图标</a-button>
                <template #content>
                  <div style="max-width:380px">
                    <div style="margin:4px 0;font-size:12px;color:var(--color-text-3)">Arco 图标</div>
                    <div style="display:grid;grid-template-columns:repeat(8,1fr);gap:6px;max-height:200px;overflow:auto;margin-bottom:8px">
                      <div v-for="n in arcoIconList" :key="'a-'+n"
                           @click="form[field]=n"
                           :title="n"
                           style="display:flex;align-items:center;justify-content:center;height:32px;cursor:pointer;border:1px solid var(--color-border-2);border-radius:4px">
                        <component :is="'icon-'+n" />
                      </div>
                    </div>
                    <div style="margin:4px 0;font-size:12px;color:var(--color-text-3)">自定义 SVG</div>
                    <div style="display:grid;grid-template-columns:repeat(8,1fr);gap:6px;max-height:200px;overflow:auto">
                      <div v-for="n in svgIconList" :key="'s-'+n"
                           @click="form[field]='svg-'+n"
                           :title="'svg-'+n"
                           style="display:flex;align-items:center;justify-content:center;height:32px;cursor:pointer;border:1px solid var(--color-border-2);border-radius:4px">
                        <svg-icon :name="n" :size="18" />
                      </div>
                    </div>
                  </div>
                </template>
              </a-popover>
            </a-space>
          </a-form-item>
          <!--分类级联-->
          <a-form-item v-else-if="column.form==='selectCascader'" :key="field + '-selectCascader'"
                       :label="column.name"
                       :required="column.required||false" >
            selectCascader
          </a-form-item>
          <!--两级联动选择（分别存两个字段） -->
          <a-form-item v-else-if="column.form==='linkSelect'" :key="field + '-linkSelect'"
                       :label="column.name"
                       :required="column.required||false" >
            <div style="display:flex;width:100%;align-items:center" v-if="data && data.options">
              <a-select style="flex:1;min-width:0"
                        v-model="form[field]"
                        allow-clear
                        allow-search
                        :placeholder="(data.options[field] && data.options[field].length) ? (column.placeholder||'请选择') : '加载中...'"
                        :disabled="column.disabled||false"
                        @change="(val)=>bindLinkSelectChange(field, val, column)">
                <a-option v-for="(opt,k) in (data.options[field]||[])" :key="(opt&&opt.value)?opt.value:'_r'+k" :value="(opt&&opt.value)?opt.value:''">{{ (opt&&opt.label)?opt.label:'' }}</a-option>
              </a-select>
              <!-- 数据无 children 或有逗号分隔 → 只显示一级自动填充 -->
              <template v-if="!_linkHasChildren || !_linkHasChildren[field] || String(column.linkField||'').indexOf(',') > -1"></template>
              <template v-else>
                <span style="margin:0 8px;flex-shrink:0;color:#86909c">/</span>
                <a-select style="flex:1;min-width:0"
                          :key="field + '_' + (form[field] || '')"
                          v-model="form[column.linkField]"
                          allow-clear
                          allow-search
                          :placeholder="_linkChildOptions[field] && _linkChildOptions[field].length ? (column.linkPlaceholder||'请选择') : '请先选择'+(column.name||'上级')"
                          :disabled="!form[field] || column.disabled||false">
                  <a-option v-for="(co,ck) in (_linkChildOptions[field]||[])" :key="(co&&co.value)?co.value:'_c'+ck" :value="(co&&co.value)?co.value:''">{{ (co&&co.label)?co.label:'' }}</a-option>
                </a-select>
              </template>
            </div>
            <div v-else style="color:#86909c;padding:4px 0">加载中...</div>
          </a-form-item>
          <!--分类级联远程-->
          <a-form-item v-else-if="column.form==='selectCascaderRemote'" :key="field + '-selectCascaderRemote'"
                       :label="column.name"
                       :required="column.required||false" >
            <!--分类-->
            <a-select style="width: 40%;"
                      v-model="form[field]"
                      :disabled="column.disabled||false" >
              <a-option v-for="opt in data.options[field]" :key="opt.value" :value="opt.value">{{opt.label}}</a-option>
            </a-select>
            <!--远程选择-->
            <a-select style="width: 58%; margin-left: 2%;"
                      v-model="form[field]"
                      :disabled="column.disabled||false" >
              <a-option v-for="opt in data.options[field]" :key="opt.value" :value="opt.value">{{opt.label}}</a-option>
            </a-select>
          </a-form-item>
          <!--级联-->
          <a-form-item v-else-if="column.form==='cascader'" :key="field + '-cascader'"
                       :label="column.name"
                       :required="column.required||false" >
            <a-cascader expand-trigger="hover" :change-on-select="true" placeholder="默认"
                        v-model="form[field]"
                        :options="computedTreeData(field, true)"
                        :disabled="column.disabled||false"
                        :filterable="true" />
          </a-form-item>
          <!--周选择-->
          <a-form-item v-else-if="column.form==='weekpicker'" :key="field + '-weekpicker'"
                       :label="column.name"
                       :required="column.required||false" >
            <a-date-picker v-model="form[field]"
                           mode="week"
                           :placeholder="column.name"
                           :disabled="column.disabled||false" style="width: 200px;" />
          </a-form-item>
          <!--日期选择-->
          <a-form-item v-else-if="column.form==='datepicker'" :key="field + '-datepicker'"
                       :label="column.name"
                       :required="column.required||false" >
            <a-date-picker v-model="form[field]"
                           mode="date"
                           :placeholder="column.name"
                           :disabled="column.disabled||false"
                           style="width:100%" />
          </a-form-item>
          <!--月份选择-->
          <a-form-item v-else-if="column.form==='monthpicker'" :key="field + '-monthpicker'"
                       :label="column.name"
                       :required="column.required||false" >
            <a-date-picker v-model="form[field]"
                           mode="month"
                           :placeholder="column.name"
                           :disabled="column.disabled||false" style="width:100%" />
          </a-form-item>
          <!--季度选择-->
          <a-form-item v-else-if="column.form==='quarterpicker'" :key="field + '-quarterpicker'"
                       :label="column.name"
                       :required="column.required||false" >
            <a-date-picker v-model="form[field]"
                           mode="quarter"
                           :placeholder="column.name"
                           :disabled="column.disabled||false" style="width:100%" />
          </a-form-item>
          <!--年份选择-->
          <a-form-item v-else-if="column.form==='yearpicker'" :key="field + '-yearpicker'"
                       :label="column.name"
                       :required="column.required||false" >
            <a-date-picker v-model="form[field]"
                           mode="year"
                           :placeholder="column.name"
                           :disabled="column.disabled||false" style="width:100%" />
          </a-form-item>
          <!--日期时间选择-->
          <a-form-item v-else-if="column.form==='datetimepicker'" :key="field + '-datetimepicker'"
                       :label="column.name"
                       :required="column.required||false" >
            <a-date-picker v-model="form[field]"
                           mode="datetime"
                           :placeholder="column.name"
                           :disabled="column.disabled||false" style="width: 200px;"
                           show-time format="YYYY-MM-DD HH:mm:ss" />
          </a-form-item>
          <!--时间选择-->
          <a-form-item v-else-if="column.form==='timepicker'" :key="field + '-timepicker'"
                       :label="column.name"
                       :required="column.required||false" >
            <a-time-picker v-model="form[field]"
                           :placeholder="column.name"
                           format="HH:mm"
                           :disabled="column.disabled||false" style="width: 200px;" />
          </a-form-item>
           <!--时间选择秒-->
          <a-form-item v-else-if="column.form==='timepickers'" :key="field + '-timepickers'"
                       :label="column.name"
                       :required="column.required||false" >
            <a-time-picker v-model="form[field]"
                           :placeholder="column.name"
                           format="HH:mm:ss"
                           :disabled="column.disabled||false" style="width: 200px;" />
          </a-form-item>
          <!--日期范围-->
          <a-form-item v-else-if="column.form==='daterangepicker'" :key="field + '-daterangepicker'"
                       :label="column.name"
                       :required="column.required||false" >
            <a-range-picker v-model="form[field]"
                            :placeholder="[column.name+'(开始)', column.name+'(结束)']"
                            :disabled="column.disabled||false"
                            style="width:100%" />
          </a-form-item>
          <!--周范围-->
          <a-form-item v-else-if="column.form==='weekrangepicker'" :key="field + '-weekrangepicker'"
                       :label="column.name"
                       :required="column.required||false" >
            <a-range-picker v-model="form[field]" mode="week"
                            :placeholder="[column.name+'(开始)', column.name+'(结束)']"
                            :disabled="column.disabled||false"
                            style="width:100%" />
          </a-form-item>
          <!--月份范围-->
          <a-form-item v-else-if="column.form==='monthrangepicker'" :key="field + '-monthrangepicker'"
                       :label="column.name"
                       :required="column.required||false" >
            <a-range-picker v-model="form[field]" mode="month"
                            :placeholder="[column.name+'(开始)', column.name+'(结束)']"
                            :disabled="column.disabled||false"
                            style="width:100%" />
          </a-form-item>
          <!--季度范围-->
          <a-form-item v-else-if="column.form==='quarterrangepicker'" :key="field + '-quarterrangepicker'"
                       :label="column.name"
                       :required="column.required||false" >
            <a-range-picker v-model="form[field]" mode="quarter"
                            :placeholder="[column.name+'(开始)', column.name+'(结束)']"
                            :disabled="column.disabled||false"
                            style="width:100%" />
          </a-form-item>
          <!--年份范围-->
          <a-form-item v-else-if="column.form==='yearrangepicker'" :key="field + '-yearrangepicker'"
                       :label="column.name"
                       :required="column.required||false" >
            <a-range-picker v-model="form[field]" mode="year"
                            :placeholder="[column.name+'(开始)', column.name+'(结束)']"
                            :disabled="column.disabled||false"
                            style="width:100%" />
          </a-form-item>
          <!--日期时间范围-->
          <a-form-item v-else-if="column.form==='datetimerangepicker'" :key="field + '-datetimerangepicker'"
                       :label="column.name"
                       :required="column.required||false" >
            <a-range-picker v-model="form[field]" show-time
                            format="YYYY-MM-DD HH:mm:ss"
                            :placeholder="[column.name+'(开始)', column.name+'(结束)']"
                            :disabled="column.disabled||false"
                            style="width:100%" />
          </a-form-item>
          <!--时间范围-->
          <a-form-item v-else-if="column.form==='timerangepicker'" :key="field + '-timerangepicker'"
                       :label="column.name"
                       :required="column.required||false" >
            <a-time-picker type="time-range" v-model="form[field]"
                           format="HH:mm:ss"
                           :disabled="column.disabled||false"
                           style="width:100%" />
          </a-form-item>
          <!--平面布局-->
          <a-form-item v-else-if="column.form==='indoorMarker'" :key="field + '-indoorMarker'"
                       :label="column.name+'（布局完成后请点击确认布局按钮后再进行提交）'"
                       :required="column.required||false" >
            <f-indoor-marker :name="field" :image="form['image']"
                             :value="form[field]" :disableEdit="true"
                             :disabled="column.disabled||false"
                             @change="bindChangeIndoorMarker" />
          </a-form-item>
          <!--签名上传-->
          <a-form-item v-else-if="column.form==='esign'" :key="field + '-esign'"
                       :label="column.name"
                       :required="column.required||false" >
            <div class="clearfix esign">
              <f-esign :name="field"
                              :value="form[field]"
                              :fileList="fileList"
                              :sudisabled="column.disabled||false"
                              @change="bindUploadEsgin" />
            </div>
          </a-form-item>
          <!--签名上传base64-->
          <a-form-item v-else-if="column.form==='esignbm'" :key="field + '-esignbm'"
                       :label="column.name"
                       :required="column.required||false" >
            <div class="clearfix esign">
              <f-esign-bm :name="field"
                              :value="form[field]"
                              :sudisabled="column.disabled||false"
                              @change="bindUploadEsgin" />
            </div>
          </a-form-item>
            <!--签名上传base64图片-->
          <a-form-item v-else-if="column.form==='imagebm'" :key="field + '-imagebm'"
                       :label="column.name"
                       :required="column.required||false" >
            <div class="clearfix esign">
              <f-upload-image-bm :name="field"
                              :value="form[field]"
                              :fileList="fileList"
                              :sudisabled="column.disabled||false"
                              @change="bindUploadEsgin" />
            </div>
          </a-form-item>
          <!--单图上传-->
          <a-form-item v-else-if="column.form==='image'" :key="field + '-image'"
                       :label="column.name"
                       :required="column.required||false" >
            <div class="clearfix">
              <f-upload-image :name="field"
                              :value="form[field]"
                              :fileList="fileList"
                              :disabled="column.disabled||false"
                              @change="bindUploadImage" />
            </div>
          </a-form-item>
          <!--多图上传-->
          <a-form-item v-else-if="column.form==='images'" :key="field + '-images'"
                       :label="column.name"
                       :required="column.required||false" >
            <div class="clearfix">
              <f-upload-images :name="field" :limit="8"
                               :value="form[field]"
                               :disabled="column.disabled||false"
                               @change="bindUploadImages" />
            </div>
          </a-form-item>
          <!--文件上传-->
          <a-form-item v-else-if="column.form==='file'" :key="field + '-file'"
                       :label="column.name"
                       :required="column.required||false" >
            <div class="clearfix">
              <f-upload-file :name="field" :limit="8"
                             :value="form[field]"
                             :disabled="column.disabled||false"
                             :accept="column.accept||null"
                             @change="bindFileUpload" />
            </div>
          </a-form-item>
           <a-form-item v-else-if="column.form==='filexxk'" :key="field + '-filexxk'"
                       :label="column.name"
                       :required="column.required||false" >
            <div class="clearfix">
              <f-upload-file :name="field" :limit="8"
                             :value="form[field]"
                             :disabled="column.disabled||false"
                             :accept="column.accept||null"
                             @change="bindFileUpload" />
            </div>
          </a-form-item>
          <!--Flash上传-->
          <a-form-item v-else-if="column.form==='flash'" :key="field + '-flash'"
                       :label="column.name"
                       :required="column.required||false" >
            <div class="clearfix">
              <f-upload-file :name="field" :limit="8"
                             :value="form[field]"
                             :disabled="column.disabled||false"
                             @change="bindFileUpload" />
            </div>
          </a-form-item>
          <!--地图标点-->
          <a-form-item v-else-if="column.form==='mapPoint'" :key="field + '-mapPoint'"
                       :label="column.name"
                       :required="column.required||false" >
            <template v-if="typeof BMap !== 'undefined'">
            <baidu-map class="map"
                       ak="R2eTZTK1CIATNfGZSSLu5IdYodrCKrcq"
                       v-if="form[field] && form[field].lng && form[field].lat"
                       :center="form[field]" :zoom="16"
                       @click="bindMapPoint" >
              <bm-view :id="field" style="width: 100%; height:100%; flex: 1" />
              <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT" type="BMAP_NAVIGATION_CONTROL_ZOOM" />
              <bm-marker :position="form[field]" animation="BMAP_ANIMATION_DROP" />
            </baidu-map>
            </template>
            <span v-else>暂无数据</span>
          </a-form-item>
          <!--高德地图标点未完成-->
          <a-form-item v-else-if="column.form==='amapPoint'" :key="field + '-amapPoint'"
                       :label="column.name"
                       :required="column.required||false" >
            <template v-if="typeof BMap !== 'undefined'">
            <baidu-map class="map"
                       ak="R2eTZTK1CIATNfGZSSLu5IdYodrCKrcq"
                       :center="form[field]" :zoom="16"
                       @click="bindaMapPoint" >
              <bm-view :id="field" style="width: 100%; height:100%; flex: 1" />
              <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT" type="BMAP_NAVIGATION_CONTROL_ZOOM" />
              <bm-marker :position="form[field]" animation="BMAP_ANIMATION_DROP" />
            </baidu-map>
            </template>
            <span v-else>暂无数据</span>
          </a-form-item>
          <!--单纯显示-->
          <a-form-item v-else-if="column.form==='show'" :key="field + '-show'"
                       :label="column.name"
                       :required="column.required||false" >
            <a-input v-model="form[field]" disabled />
          </a-form-item>
          <!--单纯传值-->
          <a-form-item v-else-if="column.form==='onlySetValue'" :key="field + '-onlySetValue'" style="display: none;"
                       :label="column.name"
                       :required="column.required||false" >
            <a-input v-model="form[field]" disabled />
          </a-form-item>
          <!--隐藏-->
          <template v-else-if="column.form==='hidden'" :key="field + '-hidden'"></template>
          <!--未知-->
          <a-form-item v-else :key="field + '-default'"
                       :label="column.name" >
            未知表单类型：{{column.form}}
          </a-form-item>
          </a-col>
        </template>
      </template>
      </a-row>
    </a-form>
  </div>
</template>

<script>
  import * as ArcoIcons from '@arco-design/web-vue/es/icon'
  import md5 from 'md5'
  import FCodeEditor from 'vue-json-editor'
  // Vue 3 富文本编辑器
  import { QuillEditor } from '@vueup/vue-quill'
  import '@vueup/vue-quill/dist/vue-quill.snow.css'

  const env = require('../../../env/index')

  /* 枚举 Arco 真实存在的图标名（短名，如 user），替代手写列表，避免空白图标 */
  const arcoIconList = Object.keys(ArcoIcons)
    .filter(k => /^Icon[A-Z]/.test(k))
    .map(k => k.slice(4).replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase())
  /* 枚举项目自定义 SVG 图标（src/assets/svg 目录），选中后存 svg-xxx */
  /* webpack 环境用 require.context（非 Vite 的 import.meta.glob） */
  const svgContext = require.context('../../assets/svg', false, /\.svg$/)
  const svgIconList = svgContext.keys().map(p => p.replace(/^\.\//, '').replace(/\.svg$/, ''))

  import moment from 'moment'
  import 'moment/locale/zh-cn'
  moment.locale('zh-cn')
  const toolbarOptions = [
    ['bold', 'italic', 'underline', 'strike'],
    ['blockquote', 'code-block'],
    [{'header': 1}, {'header': 2}],
    [{'list': 'ordered'}, {'list': 'bullet'}],
    [{'script': 'sub'}, {'script': 'super'}],
    [{'indent': '-1'}, {'indent': '+1'}],
    [{'direction': 'rtl'}],
    [{'size': ['small', false, 'large', 'huge']}],
    [{'header': [1, 2, 3, 4, 5, 6, false]}],
    [{'color': []}, {'background': []}],
    [{'font': []}],
    [{'align': []}],
    ['link', 'image', 'video'],
    ['clean']
  ]
  export default {
    name: 'FForm',
    props: {
      superApi: String,
      superData: Object,
      sudisabled: Boolean,
      colSpan: { type: Number, default: 0 }  // 0=自动判断，12=2列，24=1列
    },
    components: {
      FCodeEditor,
      QuillEditor,
    },
    created() {
      this.page = this.$fan.utils.parse(this.def.page)
    },
    mounted() {
      this.loadData()
    },
    computed: {
      colSpanAuto() {
        if (this.colSpan > 0) return this.colSpan
        // 自动判断：字段<=10则1列，>10则2列
        return Object.keys(this.columns).length > 8 ? 12 : 24
      },
      type() {
        let type = 'add'
        if (this.data.data.id) {
          type = 'edit'
        }
        return type
      },
      columns() {
        const columns = {}
        for (let k in this.data.columns) {
          const column = this.data.columns[k]
          if (!column.hidden || column.hidden.indexOf(this.type)<0) {
            columns[k] = column
          }
        }
        return columns
      },
      api() {
        let api = this.$fan.utils.parse(this.superApi)
        const apis = api.split('?')
        if (apis[0] && apis[0].indexOf('v_') > -1) {
          return apis[0].split('v_')[1]
        } else if (apis[0] && apis[0].indexOf('v2_') > -1) {
          return apis[0].split('v2_')[1]
        }
        return apis[0]
      },
      defaultFormValue() {
        let api = this.$fan.utils.parse(this.superApi)
        const apis = api.split('?')
        if (apis[1]) {
          let defaultFormValue = {}
          const formValues = apis[1].split('&')
          for (let k in formValues) {
            const formValue = formValues[k].split('=')
            defaultFormValue[formValue[0]] = formValue[1]
          }
          return defaultFormValue
        }
        return {}
      }
    },
    data() {
      return {
        page: {},
        def: {
          page: {
            loading: {
              page: false,
              submit: false,
            },
            labelCol: {span: 8},
            wrapperCol: {span: 16}
          }
        },
        data: {
          columns: {},
          keyinfo: {},
          options: {},
          data: {},
          dateTimeFormat: 'YYYY-MM-DD HH:mm:ss',
          timeFormat: 'HH:mm:ss',
          monthFormat: 'YYYY/MM',
        },
        options: {},
        form: {},
        arcoIconList,
        svgIconList,
        _linkChildOptions: {}, /* linkSelect 第二级选项缓存（按需加载） */
        _linkHasChildren: {}, /* linkSelect 数据是否有 children */
        fileList:[],
        editorOption: {                
                    modules: {
                        toolbar: {
                            container: toolbarOptions,
                            handlers: {
                                'image': function (value) {
                                    if (value) {
                                        alert('自定义图片')
                                    } else {
                                        this.quill.format('image', false);
                                    }
                                }
                            }
                        }
                    }
                }
      }
    },
    methods: {
      moment,
      /* 获取 numberWithUnit 的配套单位字段名：优先 column.unitField，否则 {dataIndex}_unit */
      getUnitField(column, field) {
        return column.unitField || (field + '_unit')
      },
      /* 图标字段预览：把存储的短名（如 user）解析为 Arco 全局图标组件名（icon-user），已带前缀则原样返回 */
      iconPreview(val) {
        if (!val) return ''
        const s = String(val).trim()
        if (!s) return ''
        return s.startsWith('icon-') ? s : 'icon-' + s
      },
      /* 判断图标值是否为自定义 SVG（svg- 前缀），与 layout.vue 的 isSvgIcon 约定一致 */
      isSvgIcon(val) {
        return val && String(val).startsWith('svg-')
      },
      /* 从 svg-aq 中取出 svg 名 aq */
      svgName(val) {
        return val ? String(val).replace('svg-', '') : ''
      },
      async loadData() {
        this.page.loading.page = true
        const data = this.$store.state.page
        this.data = this.$fan.utils.parse(data)
        this.data.data = this.$fan.utils.parse(this.superData)
        // parse 会丢掉函数，从原始 store 恢复 defaultValue
        if (data && data.columns) {
          for (var kk in data.columns) {
            if (data.columns[kk].defaultValue != null && this.data.columns[kk]) {
              this.data.columns[kk].defaultValue = data.columns[kk].defaultValue
            }
          }
        }
        this.form = await this.recombineDataByUserToForm(this.data.data, this.data.columns)
        this.form = await this.recombineDataToForm(this.data.data, this.data.columns)
        /* 初始化 linkSelect：注册 linkField 到 form */
        var cols = this.data.columns || {}
        for (var k in cols) {
          if (cols[k] && cols[k].form === 'linkSelect' && cols[k].linkField) {
            if (!this.form[cols[k].linkField]) {
              this.form[cols[k].linkField] = undefined
            }
          }
        }
        /* linkSelect 编辑时初始化：触发 change 加载二级数据，保留原值 */
        for (var f in cols) {
          var cc = cols[f]
          if (cc && cc.form === 'linkSelect' && cc.linkField && this.form[f]) {
            var saved = this.form[cc.linkField]
            this.bindLinkSelectChange(f, this.form[f], cc)
            if (saved !== undefined && saved !== null) {
              this.form[cc.linkField] = String(saved)
            }
          }
        }
        for (var k2 in cols) {
          /* 初始化 numberWithUnit：注册配套字段到 form，并从 DB 数据 / store 读取选项 */
          if (cols[k2] && cols[k2].form === 'numberWithUnit') {
            const unitField = this.getUnitField(cols[k2], k2)
            // 从 DB 数据中恢复配套字段的值（编辑时 data.data 有 xjunit 等字段）
            if (this.data.data && this.data.data[unitField] !== undefined) {
              this.form[unitField] = this.data.data[unitField]
            } else if (!this.form[unitField]) {
              this.form[unitField] = undefined
            }
            // 从 store.page.options 加载选项到 data.options[unitField]
            const storeOpts = data.options || {}
            if (storeOpts[unitField]) {
              this.data.options[unitField] = storeOpts[unitField]
            }
            // 如果 store 中没有，尝试加载（从原始 page columns 获取 unitExtendTable/unitExtendOption）
            const origCol = cols[k] || {}
            if (!storeOpts[unitField] && (origCol.unitExtendTable || origCol.unitExtendOption)) {
              this.loadUnitOptions(k, unitField, origCol)
            }
          }
        }
        this.page.loading.page = false
      },
      /* 为 numberWithUnit 加载单位选项 */
      async loadUnitOptions(mainField, unitField, origCol) {
        try {
          if (origCol.unitExtendTable) {
            const res = await this.$fan.api.get(origCol.unitExtendTable, { page: 1, limit: 99999 })
            let data = (res && res.data) ? res.data : (res || [])
            if (data && data.data && Array.isArray(data.data)) data = data.data
            if (data && data.length > 0) {
              this.data.options[unitField] = data.map(item => ({
                label: item.name || item.title || String(item.id),
                value: item.id
              }))
            }
          } else if (origCol.unitExtendOption) {
            const res = await this.$fan.api.get(`base_options?feature=${origCol.unitExtendOption}`, { page: 1, limit: 99999 })
            let list = (res && res.data) ? res.data : null
            if (list && list.data && Array.isArray(list.data) && list.data.length > 0 && list.data[0].options) list = list.data
            if (list && Array.isArray(list) && list.length > 0 && list[0].options) {
              const opts = list[0].options
              this.data.options[unitField] = []
              for (const k in opts) {
                const v = /^\d+$/.test(k) ? parseInt(k) : k
                this.data.options[unitField].push({ label: opts[k], value: v })
              }
            }
          }
        } catch (e) {
          console.warn('loadUnitOptions 失败:', e)
        }
      },
      async actionFormSubmit() {
        this.page.loading.submit = true
        if (this.type === 'edit') {
          const req = this.checkEditFormToReq(
            this.$fan.utils.parse(this.form),
            this.$fan.utils.parse(this.data.data),
            this.$fan.utils.parse(this.data.columns)
          )
          if (req && req.error_message === '未检测到任何修改') {
            // 无变化但图片可能被上传，强制提交所有表单字段
            const form = this.$fan.utils.parse(this.form)
            const cols = this.$fan.utils.parse(this.data.columns)
            const allReq = {}
            for (let field in cols) {
              const val = form[field]
              if (val !== undefined && val !== null && val !== '') {
                allReq[field] = val
              }
            }
            allReq.id = this.data.data.id
            const {data} = await this.$fan.api.put(`${this.api}/${this.data.data.id}`, allReq)
            if (data && data.data && data.data>0) this.$emit('emitReloadData', allReq)
            else this.$emit('emitReloadData', allReq)
          } else if (req && req.error_message) {
            this.$message.warning(req.error_message)
          } else if (req && Object.keys(req).length > 0) {
            const {data} = await this.$fan.api.put(`${this.api}/${this.data.data.id}`, req)
            if (data && data.data && data.data>0) {
              this.$emit('emitReloadData', req)
            }
          } else {
            this.$message.warning('未检测到任何修改')
          }
        } else {
          const req = this.checkAddFormToReq(
            this.$fan.utils.parse(this.form),
            this.$fan.utils.parse(this.data.data),
            this.$fan.utils.parse(this.data.columns)
          )
          if (req.error_message) {
            this.$message.warning(req.error_message)
          } else {
            const {data} = await this.$fan.api.post(`${this.api}`, req)
            if (data && data.data && data.data>0) {
              this.$emit('emitReloadData', req)
            }
          }
        }
        this.page.loading.submit = false
      },
      async recombineDataByUserToForm(data, columns) {
        const keyinfo = this.$fan.utils.parse(this.data.keyinfo)
        let form = {}
        const userInfo = this.$store.state.user
        if (userInfo.id_auth_role>1 && userInfo.id_entity) {
          let field = false
          if (columns.hasOwnProperty('id_entity')) {
            field = 'id_entity'
          } else if (columns.hasOwnProperty('id_entity_xiaofang')) {
            field = 'id_entity_xiaofang'
          } else if (columns.hasOwnProperty('id_base_org')) {
            field = 'id_base_org'
          } else if (columns.hasOwnProperty('pid') && this.api=='entity_xiaofang') {
            field = 'pid'
            if (this.data.data.id == userInfo.id_entity && userInfo.id_auth_role!=1) {
              this.columns[field].disabled = true
            } else {
              this.columns[field].disabled = false
            }
          }
          if (field) {
            form[field] = keyinfo[field][userInfo.id_entity].value
          }
        }
        return form
      },
      async recombineDataToForm(data, columns) {
          const keyinfo = this.$fan.utils.parse(this.data.keyinfo);
          let form = {};

          for (let field in columns) {
              const column = columns[field];
              if (!column.hidden || column.hidden.indexOf(this.type) < 0) {
                  let initialValue;

                  if (column.defaultValue !== undefined) {
                      initialValue = typeof column.defaultValue === 'function' 
                          ? column.defaultValue() 
                          : column.defaultValue;
                  } 
                  else if (data[field] !== undefined) {
                      initialValue = data[field];
                  } 
                  else {
                      initialValue = null;
                  }

                  if (column.form === 'password') {
                      form[field] = '';
                  } else if (['cascader'].indexOf(column.form) > -1) {
                      form[field] = initialValue != null ? String(initialValue) : '';
                  } else if (column.form === 'selectTree') {
                      if (initialValue == null) {
                        form[field] = column.checkable !== false ? [] : undefined
                      } else if (Array.isArray(initialValue)) {
                        form[field] = initialValue
                      } else {
                        form[field] = String(initialValue).split(',').filter(Boolean)
                      }
                  } else if (column.form === 'selectTreeMultiple') {
                      if (initialValue == null) {
                        form[field] = []
                      } else if (Array.isArray(initialValue)) {
                        form[field] = initialValue.map(String)
                      } else {
                        form[field] = String(initialValue).split(',').filter(Boolean)
                      }
                  } else if (['checkbox', 'selectMultiple', 'tags'].indexOf(column.form) > -1) {
                      form[field] = initialValue ? JSON.parse(JSON.stringify(initialValue)) : [];
                  } else if (column.form === 'mapPoint' || column.form === 'amapPoint') {
                      if (initialValue && initialValue.x && initialValue.y) {
                          form[field] = { lng: initialValue.x, lat: initialValue.y };
                      } else {
                          form[field] = { lng: 115.915731, lat: 28.68169 };
                      }
                  } else if (column.form === 'numberWithUnit') {
                      form[field] = (initialValue != null) ? Number(initialValue) : undefined
                  } else if (['datepicker', 'monthpicker', 'quarterpicker', 'datetimepicker', 'timepicker', 'timepickers', 'weekpicker', 'yearpicker'].indexOf(column.form) > -1) {
                      let format = '';
                      switch(column.form) {
                        case 'datepicker': format = 'YYYY-MM-DD'; break;
                        case 'monthpicker': format = 'YYYY-MM'; break;
                        case 'quarterpicker': format = 'YYYY-[Q]Q'; break;
                        case 'datetimepicker': format = 'YYYY-MM-DD HH:mm:ss'; break;
                        case 'timepicker': format = 'HH:mm'; break;
                        case 'timepickers': format = 'HH:mm:ss'; break;
                        case 'weekpicker': format = 'YYYY-WW'; break;
                        case 'yearpicker': format = 'YYYY'; break;
                      }
                    form[field] = initialValue ? moment(initialValue, format) : undefined;
                  } else if (['daterangepicker','weekrangepicker','monthrangepicker','quarterrangepicker','yearrangepicker','datetimerangepicker'].indexOf(column.form) > -1) {
                      let format = '';
                      switch(column.form) {
                        case 'daterangepicker': format = 'YYYY-MM-DD'; break;
                        case 'weekrangepicker': format = 'YYYY-WW'; break;
                        case 'monthrangepicker': format = 'YYYY-MM'; break;
                        case 'quarterrangepicker': format = 'YYYY-[Q]Q'; break;
                        case 'yearrangepicker': format = 'YYYY'; break;
                        case 'datetimerangepicker': format = 'YYYY-MM-DD HH:mm:ss'; break;
                      }
                      form[field] = initialValue ? (typeof initialValue === 'string' ? initialValue.split(',').map(s => s ? moment(s.trim(), format) : undefined) : (Array.isArray(initialValue) ? initialValue.map(v => v ? moment(v, format) : undefined) : [])) : undefined;
                  } else if (column.form === 'timerangepicker') {
                      form[field] = initialValue ? (typeof initialValue === 'string' ? initialValue.split(',').map(s => s ? s.trim() : '') : (Array.isArray(initialValue) ? initialValue.map(v => String(v || '')) : [])) : ['', ''];
                  } else if (['number', 'number100', 'decimal'].indexOf(column.form) > -1 && initialValue != null) {
                    form[field] = Number(initialValue)
                  } else {
                      if (['text[]', 'int[]'].indexOf(column.type) > -1 && !initialValue) {
                          form[field] = [];
                      } else if (['select', 'selectString', 'id'].indexOf(column.form) > -1 && initialValue === null) {
                        form[field] = undefined;
                      } else if (!initialValue && column.defaultValue != null) {
                          form[field] = typeof column.defaultValue === 'function' ? column.defaultValue() : column.defaultValue;
                      } else {
                          form[field] = initialValue;
                      }
                  }

                  if (this.superFilter && this.superFilter[field]) {
                      form[field] = this.$fan.utils.parse(this.superFilter[field]);
                  }
                  
                  this.data.data[field] = form[field];
              }
          }

          return form;
      },
      checkEditFormToReq(form, data, columns) {
        const req = {};
        let hasChanges = false;
        const isEmpty = (val) => val === undefined || val === null || val === '';

        for (let field in columns) {
          const column = columns[field];
          if (!column.hidden || column.hidden.indexOf(this.type) < 0) {
            let newValue = form[field];
            const oldValue = data[field];
            // moment 对象转字符串再比对
            if (newValue && typeof newValue === 'object' && newValue._isAMomentObject) {
              if (column.form === 'datepicker') newValue = moment(newValue).format('YYYY-MM-DD')
              else if (column.form === 'timepicker') newValue = moment(newValue).format('HH:mm:ss')
              else if (column.form === 'timepickers') newValue = moment(newValue).format('HH:mm:ss')
              else if (column.form === 'datetimepicker') newValue = moment(newValue).format('YYYY-MM-DD HH:mm:ss')
              else if (column.form === 'monthpicker') newValue = moment(newValue).format('YYYY-MM')
              else if (column.form === 'quarterpicker') newValue = moment(newValue).format('YYYY-[Q]Q')
              else if (column.form === 'weekpicker') newValue = moment(newValue).format('YYYY-WW')
              else if (column.form === 'yearpicker') newValue = moment(newValue).format('YYYY')
            }
            // 范围选择：moment 数组转逗号分隔字符串
            if (Array.isArray(newValue) && ['daterangepicker','weekrangepicker','monthrangepicker','quarterrangepicker','yearrangepicker','datetimerangepicker'].indexOf(column.form) > -1) {
              const fmts = { daterangepicker:'YYYY-MM-DD', weekrangepicker:'YYYY-WW', monthrangepicker:'YYYY-MM', quarterrangepicker:'YYYY-[Q]Q', yearrangepicker:'YYYY', datetimerangepicker:'YYYY-MM-DD HH:mm:ss' }
              const fmt = fmts[column.form] || 'YYYY-MM-DD'
              newValue = newValue.map(v => v ? (typeof v === 'string' ? v : (v.format ? v.format(fmt) : moment(v).format(fmt))) : '').join(',')
            }
            if (Array.isArray(newValue) && column.form === 'timerangepicker') {
              newValue = newValue.map(v => v ? (typeof v === 'string' ? v : (v.format ? v.format('HH:mm:ss') : moment(v).format('HH:mm:ss'))) : '').join(',')
            }
            const newIsEmpty = isEmpty(newValue);
            const oldIsEmpty = isEmpty(oldValue);
            const noChange = (newIsEmpty && oldIsEmpty) || (!newIsEmpty && !oldIsEmpty && JSON.stringify(newValue) === JSON.stringify(oldValue));

            // 图片字段：只有发生变化时才提交（空变空不提交；原来是图被删除时提交 null 以清空）
            if (column.form === 'image' || column.form === 'images') {
              if (newValue !== undefined) {
                if (!noChange) {
                  hasChanges = true
                  req[field] = newIsEmpty ? null : newValue
                }
              }
              continue
            }

            if (!noChange) {
              if (column.required && column.required === true && newIsEmpty) {
                return { error_message: `"${column.name}"是必填项，请注意填写` };
              }

              hasChanges = true;

              if (column.form === 'password' && newValue) {
                req[field] = md5(newValue);
              } else if (['cascader'].indexOf(column.form) > -1 && newValue) {
                req[field] = Number(newValue) || 0;
              } else if (column.form === 'selectTree' && newValue) {
                req[field] = Array.isArray(newValue) ? newValue.map(v => Number(v)).filter(v => !isNaN(v)) : Number(newValue);
              } else if (column.form === 'mapPoint' || column.form === 'amapPoint') {
                req[field] = [newValue.lng, newValue.lat];
              } else if (column.form === 'timepicker' && newValue) {
                req[field] = moment(newValue).format('HH:mm:ss');
              } else if (column.form === 'timepickers' && newValue) {
                req[field] = moment(newValue).format('HH:mm:ss');
              } else if (column.form === 'monthpicker' && newValue) {
                req[field] = moment(newValue).format('YYYY-MM');
              } else if (column.form === 'quarterpicker' && newValue) {
                req[field] = moment(newValue).format('YYYY-[Q]Q');
              } else if (column.form === 'weekpicker' && newValue) {
                req[field] = moment(newValue).format('YYYY-WW');
              } else {
                req[field] = newIsEmpty ? null : newValue;
              }
            }
            /* numberWithUnit：同时检测并提交配套的单位字段 */
            if (column.form === 'numberWithUnit') {
              const unitField = this.getUnitField(column, field)
              const unitVal = form[unitField]
              const oldUnitVal = data[unitField]
              if (unitVal !== undefined && JSON.stringify(unitVal) !== JSON.stringify(oldUnitVal)) {
                hasChanges = true
                req[unitField] = unitVal === '' || unitVal === undefined || unitVal === null ? null : unitVal
              }
            }
            /* labelField：把下拉选中项的名称顺带写入目标字段（即便目标字段 hidden 也入库） */
            if (column.labelField) {
              const selVal = form[field]
              let lv = form[column.labelField]
              if ((lv === undefined || lv === null || lv === '') && selVal !== undefined && selVal !== null && selVal !== '') {
                const opts = (this.data && this.data.options && this.data.options[field]) || []
                const found = opts.find(function(o) { return String(o.value) === String(selVal) })
                lv = found ? (found.label || '') : ''
              }
              if (lv !== undefined && lv !== null && lv !== '') {
                req[column.labelField] = lv
                hasChanges = true
              }
            }
          }
        }

        if (!hasChanges) {
          return { error_message: '未检测到任何修改' };
        }

        return req;
      },
      checkAddFormToReq(form, data, columns) {
        const req = {}
        for (let field in columns) {
          const column = columns[field]
          if (!column.hidden || column.hidden.indexOf(this.type)<0) {
            // 图片类字段：未上传/已清空时不要提交该字段（必填时则拦截提示）
            const isImageUpload = ['image', 'images'].indexOf(column.form) > -1
            const imageIsEmpty = isImageUpload && (
              form[field] === undefined || form[field] === null || form[field] === '' ||
              (Array.isArray(form[field]) && form[field].length === 0)
            )
            if (isImageUpload && column.required && imageIsEmpty) {
              return { error_message: `"${column.name}"是必填项，请上传图片` }
            }
            if (imageIsEmpty) continue
            if (column.required && column.required === true && this.$fan.utils.notSet(form[field]) && this.$fan.utils.notSet(this.defaultFormValue[field])) {
              return { error_message: `"${column.name}"是必填项，请注意填写` }
            }
            if (form[field] || form[field]===false || form[field]==='' || form[field]===0) {
              if (column.form === 'password') {
                req[field] = md5(form[field])
              } else if (['cascader'].indexOf(column.form) > -1) {
                req[field] = Number(form[field]) || 0
              } else if (column.form === 'selectTree' && form[field]) {
                const val = form[field]
                req[field] = Array.isArray(val) ? val.map(v => Number(v)).filter(v => !isNaN(v)) : Number(val)
              } else if (column.form === 'mapPoint') {
                req[field] = [form[field].lng, form[field].lat]
              } else if (column.form === 'amapPoint') {
                req[field] = [form[field].lng, form[field].lat]
              } else if (column.form === 'timepicker') {
                req[field] = moment(form[field]).format('HH:mm:ss')
              } else if (column.form === 'timepickers') {
                req[field] = moment(form[field]).format('HH:mm:ss')
              } else if (column.form === 'monthpicker') {
                req[field] = moment(form[field]).format('YYYY-MM')
              } else if (column.form === 'quarterpicker') {
                req[field] = moment(form[field]).format('YYYY-[Q]Q')
              } else if (column.form === 'weekpicker') {
                req[field] = moment(form[field]).format('YYYY-WW')
              } else if (column.form === 'yearpicker') {
                req[field] = moment(form[field]).format('YYYY')
              } else if (['daterangepicker','weekrangepicker','monthrangepicker','quarterrangepicker','yearrangepicker','datetimerangepicker'].indexOf(column.form) > -1 && Array.isArray(form[field])) {
                const fmts = { daterangepicker:'YYYY-MM-DD', weekrangepicker:'YYYY-WW', monthrangepicker:'YYYY-MM', quarterrangepicker:'YYYY-[Q]Q', yearrangepicker:'YYYY', datetimerangepicker:'YYYY-MM-DD HH:mm:ss' }
                const fmt = fmts[column.form] || 'YYYY-MM-DD'
                req[field] = form[field].map(v => v ? (typeof v === 'string' ? v : (v.format ? v.format(fmt) : moment(v).format(fmt))) : '').join(',')
              } else if (column.form === 'timerangepicker' && Array.isArray(form[field])) {
                req[field] = form[field].map(v => v ? (typeof v === 'string' ? v : (v.format ? v.format('HH:mm:ss') : moment(v).format('HH:mm:ss'))) : '').join(',')
              } else {
                req[field] = form[field]
              }
            }
            /* numberWithUnit：同时提交配套单位字段 */
            if (column.form === 'numberWithUnit') {
              const unitField = this.getUnitField(column, field)
              const unitVal = form[unitField]
              if (unitVal !== undefined && unitVal !== null && unitVal !== '') {
                req[unitField] = unitVal
              }
            }
            /* labelField：把下拉选中项的名称顺带写入目标字段（即便目标字段 hidden 也入库） */
            if (column.labelField) {
              const selVal = form[field]
              let lv = form[column.labelField]
              if ((lv === undefined || lv === null || lv === '') && selVal !== undefined && selVal !== null && selVal !== '') {
                const opts = (this.data && this.data.options && this.data.options[field]) || []
                const found = opts.find(function(o) { return String(o.value) === String(selVal) })
                lv = found ? (found.label || '') : ''
              }
              if (lv !== undefined && lv !== null && lv !== '') {
                req[column.labelField] = lv
              }
            }
          }
        }
        for(let k in this.defaultFormValue) {
          req[k] = this.defaultFormValue[k]
        }
        return req
      },
      /** selectTree：将 data.options[field]（对象/数组）转为树形数组 */
      /** 将 data.options[field] 转为树形数组
       *  isCascader=true → {value,label,children} 格式（a-cascader用）
       *  isCascader=false → {key,title,children} 格式（a-tree-select用） */
      computedTreeData(field, isCascader = false) {
        const src = this.data.options && this.data.options[field]
        if (!src) return []
        const arr = Array.isArray(src) ? src : Object.values(src).filter(v => v && typeof v === 'object')
        if (!arr.length) return []
        const make = o => {
          const node = isCascader
            ? { value: o.value ?? o.id, label: o.label ?? o.name ?? '' }
            : { key: o.key ?? o.value ?? o.id, title: o.title ?? o.label ?? o.name ?? '' }
          if (o.ntype === 'zj') node.checkable = false
          return node
        }
        const walk = list => list.map(o => {
          const node = make(o)
          if (o.children) {
            const kids = Array.isArray(o.children) ? o.children : Object.values(o.children).filter(Boolean)
            if (kids.length) node.children = walk(kids)
          }
          return node
        })
        // 已有 children → 直接转换
        if (arr.some(o => o.children)) return walk(arr)
        // 有 pid → 扁平转树
        if (arr[0] && arr[0].pid !== undefined) {
          const map = {}, tree = []
          arr.forEach(o => {
            const node = make(o); node.children = []
            map[node.value ?? node.key] = node
          })
          arr.forEach(o => {
            const id = o.value ?? o.id
            const n = map[id]; const p = map[o.pid]
            if (n && p) p.children.push(n); else if (n) tree.push(n)
          })
          const clean = a => { a.forEach(n => { if (n.children && !n.children.length) delete n.children; else if (n.children) clean(n.children) }) }
          clean(tree); return tree
        }
        return walk(arr)
      },
      bindSearchCascader(inputValue, path) {
        return (path.some(option => (option.label).toLowerCase().indexOf(inputValue.toLowerCase()) > -1))
      },
      bindFilterOption(input, option) {
        return (option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0);
      },
      bindEditorImgUpload(file, Editor, cursorLocation, resetUploader) {
        let req = new FormData()
        req.append('file', file)
        this.$fan.api.post(env.UPLOAD, req).then((res) => {
          if (res) {
            let url = `${res.data}?x-oss-process=style/default`
            Editor.insertEmbed(cursorLocation, 'image', url)
            resetUploader()
          }
        })
      },
      handleSuccess (res) {
        Message.error('图片插入失败')
      },
      bindDatePicker(field, fileName) {
      },
      bindChangeIndoorMarker(field, value) {
        console.log(value)
        console.log(this.form[field])
        this.form[field] = value
      },
      bindUploadEsgin(field, fileName) {
        this.form[field] = fileName
      },
      bindUploadImage(field, fileName) {
        this.form[field] = fileName
        this.form = Object.assign({}, this.form)
      },
      bindUploadImages(field, data) {
        this.form[field] = Array.isArray(data) ? data : [data].filter(Boolean)
      },
      bindFileUpload(field, fileName) {
        this.form[field] = fileName
      },
      bindMapPoint({target, point}) {
        this.form[target.Ua.id] = this.$fan.utils.parse(point)
      },
      bindaMapPoint({target, point}) {
        this.form[target.Va.id] = this.$fan.utils.parse(point)
      },
      bindMapGrid(req) {
      },

      /* ========== 富文本编辑器 (Quill) ========== */

      /** 标准 Quill 配置（用于 editor / quilleditor2） */
      quillOptions: function (field) {
        return {
          theme: 'snow',
          placeholder: '请输入内容...',
          modules: {
            toolbar: [
              ['bold', 'italic', 'underline', 'strike'],
              [{ 'header': 1 }, { 'header': 2 }, { 'header': false }],
              [{ 'list': 'ordered' }, { 'list': 'bullet' }],
              [{ 'indent': '-1' }, { 'indent': '+1' }],
              [{ 'align': [] }],
              [{ 'color': [] }, { 'background': [] }],
              ['blockquote', 'code-block'],
              ['link', 'image'],
              ['clean']
            ]
          }
        }
      },

      /** 带图片上传的 Quill 配置（用于 quilleditor） */
      quillOptionsWithImage: function (field) {
        var self = this
        return {
          theme: 'snow',
          placeholder: '请输入内容...',
          modules: {
            toolbar: {
              container: [
                ['bold', 'italic', 'underline', 'strike'],
                [{ 'header': 1 }, { 'header': 2 }, { 'header': false }],
                [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                [{ 'indent': '-1' }, { 'indent': '+1' }],
                [{ 'align': [] }],
                [{ 'color': [] }, { 'background': [] }],
                ['blockquote'],
                ['link', 'image'],
                ['clean']
              ],
              handlers: {
                image: function () {
                  /* 创建隐藏的文件选择 input */
                  var input = document.createElement('input')
                  input.type = 'file'
                  input.accept = 'image/*'
                  input.style.display = 'none'
                  document.body.appendChild(input)
                  input.onchange = function () {
                    var file = input.files && input.files[0]
                    if (!file) { document.body.removeChild(input); return }
                    self.bindEditorImgUpload(file, field)
                    document.body.removeChild(input)
                  }
                  input.click()
                }
              }
            }
          }
        }
      },

      /** 精简版 Quill 配置（用于 quilleditor2） */
      quillOptionsSimple: function () {
        return {
          theme: 'snow',
          placeholder: '请输入内容...',
          modules: {
            toolbar: [
              ['bold', 'italic', 'underline'],
              [{ 'list': 'ordered' }, { 'list': 'bullet' }],
              ['clean']
            ]
          }
        }
      },

      /** Quill 内容变更回调 — 确保存储 HTML 字符串 */
      onEditorChange: function (html, field) {
        if (typeof html === 'string') {
          this.form[field] = html
        } else {
          // v-model:content 在某些情况下可能传 Delta 对象
          this.form[field] = ''
        }
      },

      /** Quill 文本变化（用于 quilleditor 的图片上传定位） */
      onQuillTextChange: function () {
        // 占位：如需监听每次文本变化可在此处理
      },

      /**
       * 富文本图片上传 → 插入到对应字段的 Quill 编辑器中
       * @param {File} file - 图片文件对象
       * @param {string} field - 表单字段名
       */
      bindEditorImgUpload: function (file, field) {
        var self = this
        var req = new FormData()
        req.append('file', file)
        self.$fan.api.post(env.UPLOAD, req).then(function (res) {
          if (res && res.data) {
            var url = res.data + '?x-oss-process=style/default'
            /* 通过 ref 获取 Quill 实例并插入图片 */
            var quillRef = self.$refs['ql_' + field]
            if (quillRef && quillRef.quill) {
              var range = quillRef.quill.getSelection(true)
              quillRef.quill.insertEmbed(range.index, 'image', url)
            } else {
              /* 回退方案：直接拼接 img 标签到 HTML */
              var currentHtml = self.form[field] || ''
              self.form[field] = currentHtml + '<p><img src="' + url + '" style="max-width:100%;"/></p>'
            }
          } else {
            self.$message.error('图片上传失败')
          }
        }).catch(function () {
          self.$message.error('图片上传异常')
        })
      },
      /**
      /**
       * linkSelect：第一级改变时清空第二级 + 从store缓存找子选项（不重复请求API）
       */
      bindLinkSelectChange: function(parentField, value, column) {
        try {
          if (column && column.linkField && this.form) {
            this.form[column.linkField] = undefined
          }
          this._linkChildOptions = Object.assign({}, this._linkChildOptions)
          if (value === null || value === undefined || value === '') return

          var targetValue = String(value)
          var rawData = (this.$store.state.page && this.$store.state.page.keyinfo && this.$store.state.page.keyinfo['__raw_' + parentField]) || []
          rawData = Array.isArray(rawData) ? rawData : []

          // 检测所有数据是否有 children
          function hasAnyChildren(arr) {
            for (var i=0; i<arr.length; i++) {
              if (arr[i] && arr[i].children && arr[i].children.length > 0) return true
            }
            return false
          }
          this._linkHasChildren = Object.assign({}, this._linkHasChildren, { [parentField]: hasAnyChildren(rawData) })

          // 查找选中项
          function findById(arr, tid) {
            for (var i=0;i<arr.length;i++) {
              var it = arr[i]
              if (!it || typeof it!=='object') continue
              if (String(it.id) === tid) return it
              var ch = Array.isArray(it.children)?it.children:[]
              if (ch.length>0) { var f = findById(ch, tid); if (f) return f }
            }
            return null
          }

          // 逗号分隔 或 数据无children → 自动填充；单字段+有children → 二级下拉
          var fields = column.linkField ? column.linkField.split(',').map(function(s){return s.trim()}) : []
          var isAutoFill = String(column.linkField||'').indexOf(',') > -1 || !this._linkHasChildren[parentField]
          if (isAutoFill) {
            var item = findById(rawData, targetValue)
            if (item && item.name && fields.length === 0) {
              // 无 children 且 linkField 是单字段 → 自动填充 item 的所有非 id 字段
              for (var k in item) {
                if (k !== 'id' && k !== 'children' && k !== 'pid' && item.hasOwnProperty(k) && typeof item[k] !== 'object') {
                  fields.push(k)
                }
              }
            }
            if (item) {
              for (var fi=0; fi<fields.length; fi++) {
                var val = item[fields[fi]]
                if (val === undefined && item.name !== undefined && fields.length === 1) {
                  val = item.name
                }
                if (val !== undefined && this.form) {
                  this.form[fields[fi]] = val
                }
              }
            }
          } else {
            // 原有级联逻辑
            function collect(arr) {
              var r = []
              for (var j=0;j<arr.length;j++) {
                var it = arr[j]
                if (!it || typeof it!=='object' || it.id===undefined) continue
                var p = (it.pid!==undefined && it.pid!==null) ? String(it.pid) : ''
                if (p === targetValue) {
                  r.push({value:String(it.id), label:(typeof it.name==='string')?it.name:''})
                }
                var ch = Array.isArray(it.children)?it.children:[]
                if (ch.length>0) r = r.concat(collect(ch))
              }
              return r
            }
            var kids = collect(rawData)
            this._linkChildOptions[parentField] = kids
            this._linkChildOptions = Object.assign({}, this._linkChildOptions)
          }
        } catch(e) {
          console.warn('[linkSelect] 异常:', e?e.message:'unknown')
        }
      },
      bindSelectLabelChange: function(field, value, column) {
        try {
          if (!column || !column.labelField || !this.form) return
          if (value === null || value === undefined || value === '') {
            this.form[column.labelField] = undefined
            return
          }
          var opts = (this.data && this.data.options && this.data.options[field]) || []
          var found = opts.find(function(o) { return String(o.value) === String(value) })
          this.form[column.labelField] = found ? (found.label || '') : ''
        } catch (e) {
          console.warn('[select labelField] 异常:', e ? e.message : 'unknown')
        }
      },
    }
  }
</script>
